const box = {
  shadow: {
    z4: "0px 1px 4px rgba(28, 28, 28, 0.15)",
    z8: "0px 2px 8px rgba(28, 28, 28, 0.15)",
    z16: "0px 4px 16px rgba(28, 28, 28, 0.15)",
    z32: "0px 8px 32px rgba(28, 28, 28, 0.15)"
  }
};

export default box;
